(function () {
  function initCarousels(root) {
    root.querySelectorAll('[data-lw-carousel]').forEach(function (el) {
      if (el.dataset.lwReady) return;
      el.dataset.lwReady = '1';
      var track = el.querySelector('.lw-carousel__track');
      var step = function () {
        var item = track.firstElementChild;
        return item ? item.getBoundingClientRect().width + 16 : track.clientWidth;
      };
      el.querySelectorAll('[data-lw-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          track.scrollBy({ left: step() * Number(btn.dataset.lwDir), behavior: 'smooth' });
        });
      });
      var dots = el.querySelectorAll('.lw-dots span');
      if (dots.length) {
        track.addEventListener('scroll', function () {
          var i = Math.round(track.scrollLeft / step());
          dots.forEach(function (d, n) { d.classList.toggle('is-active', n === Math.min(i, dots.length - 1)); });
        }, { passive: true });
      }
      var interval = Number(el.dataset.lwAutoplay || 0);
      if (interval > 0) {
        setInterval(function () {
          if (el.matches(':hover')) return;
          var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
          track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step(), behavior: 'smooth' });
        }, interval * 1000);
      }
    });
  }

  function initReadMore(root) {
    root.querySelectorAll('[data-lw-readmore]').forEach(function (el) {
      if (el.dataset.lwReady) return;
      el.dataset.lwReady = '1';
      var btn = el.querySelector('.lw-readmore__toggle');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = el.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open);
      });
    });
  }

  function initCartTimer() {
    var minutes = Number(window.lwCartTimerMinutes || 0);
    if (!minutes) return;
    var key = 'lw-cart-timer-end';
    var end;
    try { end = Number(sessionStorage.getItem(key)); } catch (e) {}
    if (!end || end < Date.now()) {
      end = Date.now() + minutes * 60000;
      try { sessionStorage.setItem(key, end); } catch (e) {}
    }
    var tick = function () {
      var target = document.querySelector('[data-lw-cart-timer] [data-lw-time]');
      if (!target) return;
      var left = Math.max(0, end - Date.now());
      if (left === 0) {
        end = Date.now() + minutes * 60000;
        try { sessionStorage.setItem(key, end); } catch (e) {}
      }
      var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
      target.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    };
    tick();
    setInterval(tick, 1000);
  }

  function init(root) { initCarousels(root); initReadMore(root); }
  document.addEventListener('DOMContentLoaded', function () { init(document); initCartTimer(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
